import jsPDF from 'jspdf';
import * as QRCode from 'qrcode';

const LABEL_WIDTH = 100; // mm (10cm)
const LABEL_HEIGHT = 150; // mm (15cm)
const MARGIN = 5;
const QR_SIZE = 60;
const QR_RESOLUTION_MULTIPLIER = 8;

interface ReusedLabelData {
  code: string;
  date: string;
}

export const generateReusedLabel = async (data: ReusedLabelData): Promise<string> => {
  try {
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: [LABEL_WIDTH, LABEL_HEIGHT],
    });

    const maxTextWidth = LABEL_WIDTH - MARGIN * 2;
    const centerX = LABEL_WIDTH / 2;

    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(24);
    const splitCode = pdf.splitTextToSize(data.code, maxTextWidth);
    if (splitCode.length > 2) {
      pdf.setFontSize(18);
    }

    const codeY = MARGIN + 20;
    pdf.text(splitCode, centerX, codeY, { align: 'center' });

    const qrDataUrl = await QRCode.toDataURL(data.code, {
      width: QR_SIZE * QR_RESOLUTION_MULTIPLIER,
      margin: 1,
      color: { dark: '#000000', light: '#FFFFFF' },
    });

    const qrX = (LABEL_WIDTH - QR_SIZE) / 2;
    const qrY = codeY + 15;
    pdf.addImage(qrDataUrl, 'PNG', qrX, qrY, QR_SIZE, QR_SIZE);

    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(12);
    pdf.text(data.date, centerX, LABEL_HEIGHT - MARGIN - 10, { align: 'center' });

    const blob = pdf.output('blob');
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error('Error generating reused label:', error);
    throw error;
  }
};
